import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { DocumentGenerationParamsListStore } from "../../store/DocumentGenerationParamsListStore";

type DocumentGenerationParamsListDialogsProps = {
  store: DocumentGenerationParamsListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de DocumentGenerationParams.
 * Separado para mantener DocumentGenerationParamsListPage más limpio.
 */
export const DocumentGenerationParamsListDialogs: React.FC<DocumentGenerationParamsListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
